// src/hooks/order/useDotsCache.js
import * as React from 'react';

export function useDotsCache(productId, warehouses) {
    const storageKey = `dotsCache:${String(productId)}`;
    const [cache, setCache] = React.useState({});
    // Load from sessionStorage
    React.useEffect(() => {
        try {
            const saved = sessionStorage.getItem(storageKey);
            if (saved) {
                const parsed = JSON.parse(saved);
                if (parsed && typeof parsed === 'object') setCache(parsed);
            }
        } catch (e) {}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storageKey]);

    // Merge any fresh dots from warehouses into cache
    React.useEffect(() => {
        if (!Array.isArray(warehouses)) return;

        setCache(prev => {
            let changed = false;
            const next = { ...prev };

            warehouses.forEach(w => {
                const id = String(w?.id);

                if (Array.isArray(w?.dots)) {
                    if (w.dots.length > 0) {
                        next[id] = w.dots;
                    }
                    else if (next[id]) {
                        delete next[id];
                    }
                    changed = true;
                }
            });

            if (changed) {
                try {
                    sessionStorage.setItem(storageKey, JSON.stringify(next));
                } catch (e) {}
                return next;
            }

            return prev;
        });
    }, [warehouses, storageKey]);

    const getDotsForWh = React.useCallback(
        (whId) => cache[String(whId)] ?? [],
        [cache]
    );

    const setDotsForWh = React.useCallback((whId, dots) => {
        setCache(prev => {
            const next = { ...prev, [String(whId)]: Array.isArray(dots) ? dots : [] };
            try { sessionStorage.setItem(storageKey, JSON.stringify(next)); } catch (e) {}
            return next;
        });
    }, [storageKey]);

    const clearDotsCache = React.useCallback(() => {
        setCache({});
        try { sessionStorage.removeItem(storageKey); } catch (e) {}
    }, [storageKey]);

    return { getDotsForWh, setDotsForWh, clearDotsCache, cache };
}
